import { render, staticRenderFns } from "./customGoodDetail.vue?vue&type=template&id=302073be"
import script from "./customGoodDetail.vue?vue&type=script&lang=js"
export * from "./customGoodDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports